import { EventEmitter } from "../util/eventemitter";

// Inverse of the server's PAT_SLOT_SUBTYPES (worldpackets.ts) -- maps a
// LIST_PAT.STB subtype to the items[] slot it belongs in. Weapon subtypes
// (571-575) automatically target Weapon at 138. The server also accepts
// these subtypes in Ability at 139 when the item is dragged there.
const PAT_SUBTYPE_TO_SLOT: any = {
    511: 135, 512: 135, // frame/core
    521: 136, 522: 136, // engine
    531: 137, 532: 137, // wheel/leg
    571: 138, 572: 138, 573: 138, 574: 138, 575: 138, // weapon
    551: 139, // PAT ability/accessory
    552: 138, // castle gear arms
};

const PAT_SLOT_SUBTYPES: Record<number, number[]> = {
    135: [511, 512],
    136: [521, 522],
    137: [531, 532],
    138: [552, 571, 572, 573, 574, 575],
    139: [551, 571, 572, 573, 574, 575],
};

export const ITEMLOC = {
    GROUND: 0,
    INVENTORY: 1,
    EQUIPPED_EQUIP: 2,
    EQUIPPED_AMMO: 3,
    EQUIPPED_COSTUME: 4,
    EQUIPPED_PAT: 5,
    STORAGE_ACCOUNT: 6,
    STORAGE_PREMIUM: 7,
    STORAGE_CHARACTER: 8,
    STORAGE_ITEMMALL: 9,
    ITEMMALL_PURCHASES: 10,
    WISH_LIST: 11,
    ALL: 12,
    QUEST: 13,
};

export const INVEQUIPIDX = {
    FACE_ITEM: 1,
    HELMET: 2,
    ARMOR: 3,
    BACK: 4,
    ARMS: 5,
    BOOTS: 6,
    WEAPON: 7,
    SHIELD: 8,
    NECKLACE: 9,
    RING: 10,
    EARRING: 11,
    MAX: 12,
};

export const VISEQUIPIDX = {
    FACE: 0,
    HAIR: 1,
    HELMET: 2,
    ARMOR: 3,
    ARMS: 4,
    BOOTS: 5,
    FACE_ITEM: 6,
    BACK: 7,
    WEAPON: 8,
    SHIELD: 9,
};

export const ITEMTYPE = {
    FACE_ITEM: 1,
    HELMET: 2,
    ARMOR: 3,
    ARMS: 4,
    BOOTS: 5,
    BACK: 6,
    // Real ROSE data has exactly one itemType (7) and one STB
    // (LIST_JEWEL.STB) for all jewelry -- necklace/ring/earring aren't
    // distinguished by itemType at all, only by a field inside that STB
    // that nothing in this codebase currently reads (see TODO.md). These
    // three names are aliases of the same value, not distinct categories.
    JEWEL: 7,
    NECKLACE: 7,
    RING: 7,
    EARRING: 7,
    WEAPON: 8,
    SHIELD: 9,
    USE: 10,
    ETC: 11,
    GEM: 11,
    NATURAL: 12,
    QUEST: 13,
    RIDE_PART: 14,
    // MOUNT: 15,
    MAX: 16,
    MONEY: 31,
};

export const ITEM_DATA = {
    STANDARD_PRICE: 5,
};

export const WEAPON_DATA = {
    RANGE: 33,
    // Column index into char_motiontypes (TYPE_MOTION.STB) -- selects which
    // idle/walk/attack animation set this weapon uses.
    MOTION_TYPE: 34,
    // Row index into LIST_HITSOUND.STB. That row contains up to three
    // FILE_SOUND.STB indices used for a successful regular hit.
    HIT_SOUND: 42,
    START_SOUND: 40,
    SHOT_SOUND: 41,
};

export const ITMPARTTOVISPART: any = {};
ITMPARTTOVISPART[INVEQUIPIDX.HELMET] = VISEQUIPIDX.HELMET;
ITMPARTTOVISPART[INVEQUIPIDX.ARMOR] = VISEQUIPIDX.ARMOR;
ITMPARTTOVISPART[INVEQUIPIDX.ARMS] = VISEQUIPIDX.ARMS;
ITMPARTTOVISPART[INVEQUIPIDX.BOOTS] = VISEQUIPIDX.BOOTS;
ITMPARTTOVISPART[INVEQUIPIDX.FACE_ITEM] = VISEQUIPIDX.FACE_ITEM;
ITMPARTTOVISPART[INVEQUIPIDX.BACK] = VISEQUIPIDX.BACK;
ITMPARTTOVISPART[INVEQUIPIDX.WEAPON] = VISEQUIPIDX.WEAPON;
ITMPARTTOVISPART[INVEQUIPIDX.SHIELD] = VISEQUIPIDX.SHIELD;

export const ITMPARTTOTYPE: any = {};
ITMPARTTOTYPE[INVEQUIPIDX.FACE_ITEM] = ITEMTYPE.FACE_ITEM;
ITMPARTTOTYPE[INVEQUIPIDX.HELMET] = ITEMTYPE.HELMET;
ITMPARTTOTYPE[INVEQUIPIDX.ARMOR] = ITEMTYPE.ARMOR;
ITMPARTTOTYPE[INVEQUIPIDX.BACK] = ITEMTYPE.BACK;
ITMPARTTOTYPE[INVEQUIPIDX.ARMS] = ITEMTYPE.ARMS;
ITMPARTTOTYPE[INVEQUIPIDX.BOOTS] = ITEMTYPE.BOOTS;
ITMPARTTOTYPE[INVEQUIPIDX.WEAPON] = ITEMTYPE.WEAPON;
ITMPARTTOTYPE[INVEQUIPIDX.SHIELD] = ITEMTYPE.SHIELD;
ITMPARTTOTYPE[INVEQUIPIDX.NECKLACE] = ITEMTYPE.NECKLACE;
ITMPARTTOTYPE[INVEQUIPIDX.RING] = ITEMTYPE.RING;
ITMPARTTOTYPE[INVEQUIPIDX.EARRING] = ITEMTYPE.EARRING;

export const ITMTYPETOPART: any = {};
ITMTYPETOPART[ITEMTYPE.FACE_ITEM] = INVEQUIPIDX.FACE_ITEM;
ITMTYPETOPART[ITEMTYPE.HELMET] = INVEQUIPIDX.HELMET;
ITMTYPETOPART[ITEMTYPE.ARMOR] = INVEQUIPIDX.ARMOR;
ITMTYPETOPART[ITEMTYPE.BACK] = INVEQUIPIDX.BACK;
ITMTYPETOPART[ITEMTYPE.ARMS] = INVEQUIPIDX.ARMS;
ITMTYPETOPART[ITEMTYPE.BOOTS] = INVEQUIPIDX.BOOTS;
ITMTYPETOPART[ITEMTYPE.WEAPON] = INVEQUIPIDX.WEAPON;
ITMTYPETOPART[ITEMTYPE.SHIELD] = INVEQUIPIDX.SHIELD;
// NECKLACE/RING/EARRING are all itemType 7 (see the ITEMTYPE comment
// above), so this reverse map can only ever pick one destination slot for
// them -- there's no per-item data to tell which of the three a given
// type-7 item actually is. Defaults to Necklace; see TODO.md.
ITMTYPETOPART[ITEMTYPE.JEWEL] = INVEQUIPIDX.NECKLACE;

// Item types that can carry one gem socket (server InventoryActions.ts
// SOCKETABLE_ITEM_TYPES): jewels, weapons and offhands.
export const SOCKETABLE_ITEM_TYPES = [ITEMTYPE.JEWEL, ITEMTYPE.WEAPON, ITEMTYPE.SHIELD];

export const ITMSTACKABLE: any = {};
ITMSTACKABLE[ITEMTYPE.USE] = true;
ITMSTACKABLE[ITEMTYPE.ETC] = true;
ITMSTACKABLE[ITEMTYPE.NATURAL] = true;
ITMSTACKABLE[ITEMTYPE.QUEST] = true;

export class InventoryData extends EventEmitter {
    items: any[];
    money: any;
    // Consumable cooldown group (LIST_USEITEM col 25) -> cooldown, set by the server
    cooldowns: Map<number, { startedAt: number; durationMs: number }>;

    constructor() {
        super();
        this.items = [];
        this.money = 0;
        this.cooldowns = new Map();
    }

    setCooldown(cooldownGroup: number, cooldownMs: number) {
        this.cooldowns.set(cooldownGroup, { startedAt: Date.now(), durationMs: cooldownMs });
        this.emit("changed");
    }

    getCooldown(item: any): { startedAt: number; durationMs: number } | null {
        if (item.itemType !== ITEMTYPE.USE) {
            return null;
        }
        const itemData = GDM.getNow("item_data");
        const entry = itemData && this.cooldowns.get(itemData.getConsumableStats(item.itemNo).cooldownGroup);
        if (!entry || entry.startedAt + entry.durationMs <= Date.now()) {
            return null;
        }
        return entry;
    }

    setMoney(money: any) {
        this.money = money;
        this.emit("changed", money);
    }

    setItems(items: any) {
        this.items = items;
        this.emit("changed");
    }

    addItem(item: any) {
        if (item.itemType === ITEMTYPE.MONEY) {
            this.money = item.quantity;
            this.emit("changed", this.money);
        } else {
            let isNewItem = true;

            for (let i = 0; i < this.items.length; ++i) {
                const other = this.items[i];
                if (
                    other.location === item.location &&
                    other.slotNo === item.slotNo
                ) {
                    this.items[i] = item;
                    isNewItem = false;
                }
            }

            if (isNewItem) {
                this.items.push(item);
            }

            this.emit("changed", [item]);
        }
    }

    changeItems(changeItems: any) {
        for (let i = 0; i < changeItems.length; ++i) {
            const changeItem = changeItems[i];

            for (let j = 0; j < this.items.length; ++j) {
                let item = this.items[j];

                if (
                    item.itemKey.lo === changeItem.itemKey.lo &&
                    item.itemKey.hi === changeItem.itemKey.hi
                ) {
                    this.items[j] = changeItem.item;
                }
            }
        }

        this.emit("changed", changeItems);
    }

    appendItems(items: any) {
        this.items = this.items.concat(items);
        this.emit("changed", items);
    }

    useItem(item: any, patSlot?: number) {
        if (item.location === ITEMLOC.EQUIPPED_EQUIP || item.location === ITEMLOC.EQUIPPED_PAT) {
            // destslot=0 is the server's "find me a free backpack slot"
            // sentinel (pakChangeEquip); srcslot is item.itemKey, which is
            // already the item's raw items[] array index (see pakInventory:
            // itemkey = j). Equipped item slotNo also uses the raw index,
            // but itemKey is the source identifier sent by this packet.
            netGame.equipItem(0, item.itemKey);
        } else if (item.location === ITEMLOC.INVENTORY) {
            if (ITMTYPETOPART[item.itemType]) {
                netGame.equipItem(ITMTYPETOPART[item.itemType], item.itemKey);
            } else if (item.itemType === ITEMTYPE.USE) {
                // TODO: Use consumable on TARGET / POSITION
                netGame.useItem(item.itemKey);
            } else if (item.itemType === ITEMTYPE.RIDE_PART) {
                const itemData = GDM.getNow("item_data");
                const patStats = itemData && itemData.getPatStats(item.itemNo);
                const slot = patSlot === undefined
                    ? patStats && PAT_SUBTYPE_TO_SLOT[patStats.subtype]
                    : patSlot;
                if (patStats && PAT_SLOT_SUBTYPES[slot]?.includes(patStats.subtype)) {
                    netGame.equipItem(slot, item.itemKey);
                }
            }
            // else if (item.itemType === ITEMTYPE.MOUNT) {
            //   netGame.toggleMount(item.itemKey);
            // }
        }
    }

    dropItem(item: any) {
        ui.messageBox("Are you sure you want to drop item?", ["Yes", "No"])
            .on("yes", (answer: any) => {
                const slot = this.getSlotFromLocSlot(item.location, item.slotNo);
                netGame.dropItem(slot);
            })
            .on("no", () => {});
    }

    findByItemKey(itemKey: any) {
        for (let i = 0; i < this.items.length; ++i) {
            let item = this.items[i];

            if (item.itemKey.lo === itemKey.lo && item.itemKey.hi === itemKey.hi) {
                return item;
            }
        }

        return null;
    }

    findBySlot(slotNo: any) {
        if (slotNo < INVEQUIPIDX.MAX) {
            return this.findByLocSlot(ITEMLOC.EQUIPPED_EQUIP, slotNo);
        } else if (slotNo < INVEQUIPIDX.MAX + 120) {
            return this.findByLocSlot(ITEMLOC.INVENTORY, slotNo - INVEQUIPIDX.MAX);
        } else if (slotNo < INVEQUIPIDX.MAX + 120 + 3) {
            return this.findByLocSlot(
                ITEMLOC.EQUIPPED_AMMO,
                slotNo - INVEQUIPIDX.MAX - 120
            );
        } else if (slotNo < INVEQUIPIDX.MAX + 120 + 3 + 5) {
            return this.findByLocSlot(
                ITEMLOC.EQUIPPED_PAT,
                slotNo - INVEQUIPIDX.MAX - 120 - 3
            );
        } else {
            throw new Error("Find by slot " + slotNo);
        }
    }

    getSlotFromLocSlot(location: any, slotNo: any) {
        if (location === ITEMLOC.EQUIPPED_EQUIP) {
            return slotNo;
        } else if (location === ITEMLOC.INVENTORY) {
            return slotNo + INVEQUIPIDX.MAX;
        } else if (location === ITEMLOC.EQUIPPED_AMMO) {
            return slotNo + INVEQUIPIDX.MAX + 120;
        } else if (location === ITEMLOC.EQUIPPED_PAT) {
            return slotNo + INVEQUIPIDX.MAX + 120 + 3;
        } else {
            throw new Error("getSlotFromLocSlot " + location + " " + slotNo);
        }
    }

    findByLocSlot(location: any, slotNo: any) {
        for (let i = 0; i < this.items.length; ++i) {
            const item = this.items[i];

            if (item.location === location && item.slotNo === slotNo) {
                return item;
            }
        }

        return null;
    }

    static fromPacketData(packetData: any) {
        const invData = new InventoryData();
        invData.setMoney(packetData.money);
        invData.setItems(packetData.items);
        return invData;
    }
}
